<template>
  <div class="d-flex align-items-center" style="min-height: 100vh; background-color: #fdfdfd;">
    <div class="col-sm-8 col-md-6 col-lg-4 mx-auto" style="min-width: 300px;">
      <div class="text-center mt-5 mb-5">
        <h3 class="font-weight-bold" style="color: var(--primary-color);">TransitionCRM</h3>
      </div>

      <b-card class="shadow" style="border: none;">
        <h5 class="text-center mb-1 font-weight-bold">Reset Password</h5>
        <p class="text-center text-muted mb-4">Enter your new password</p>

        <b-form @submit.prevent="onSubmit">
          <b-form-group label="New Password" label-class="form-label">
            <div style="position: relative; display: flex; align-items: center;">
              <b-form-input
                v-model="newPassword"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Enter new password"
                required
                style="padding-right: 40px;"
              />
              <button
                type="button"
                class="btn btn-link"
                style="position: absolute; right: 0; z-index: 9; color: #858796;"
                @click="showPassword = !showPassword"
              >
                <i class="material-icons" style="font-size: 20px;">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
              </button>
            </div>
          </b-form-group>

          <b-form-group label="Confirm Password" label-class="form-label">
            <div style="position: relative; display: flex; align-items: center;">
              <b-form-input
                v-model="repeatPassword"
                :type="showRepeatPassword ? 'text' : 'password'"
                placeholder="Repeat new password"
                required
                style="padding-right: 40px;"
              />
              <button
                type="button"
                class="btn btn-link"
                style="position: absolute; right: 0; z-index: 9; color: #858796;"
                @click="showRepeatPassword = !showRepeatPassword"
              >
                <i class="material-icons" style="font-size: 20px;">{{ showRepeatPassword ? 'visibility_off' : 'visibility' }}</i>
              </button>
            </div>
          </b-form-group>

          <div v-if="error" class="alert alert-danger mt-3" role="alert">
            {{ errorMessage }}
          </div>

          <div class="form-group">
            <b-button type="submit" variant="primary" block :disabled="isLoading" style="height: 2.3rem;">
              <span v-if="isLoading">
                <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                Resetting...
              </span>
              <span v-else>Reset Password</span>
            </b-button>
          </div>

          <div class="text-center">
            Remember your password?
            <router-link :to="{ name: 'login' }" style="text-decoration: underline;">Login</router-link>
          </div>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ResetPassword',
  data() {
    return {
      newPassword: '',
      repeatPassword: '',
      error: false,
      errorMessage: '',
      isLoading: false,
      showPassword: false,
      showRepeatPassword: false,
    };
  },
  methods: {
    ...mapActions('auth', ['resetPasswordConfirm']),
    async onSubmit() {
      this.error = false;
      this.isLoading = true;

      if (this.newPassword !== this.repeatPassword) {
        this.errorMessage = 'Passwords do not match.';
        this.error = true;
        this.isLoading = false;
        return;
      }

      if (this.newPassword.length < 5) {
        this.errorMessage = 'Password must be at least 5 characters.';
        this.error = true;
        this.isLoading = false;
        return;
      }

      if (/^\d+$/.test(this.newPassword)) {
        this.errorMessage = 'Password cannot be entirely numeric.';
        this.error = true;
        this.isLoading = false;
        return;
      }

      try {
        const token = encodeURIComponent(this.$route.query.token);
        await this.resetPasswordConfirm({ password: this.newPassword, token: token });
        this.$router.push({ name: 'login', query: { passwordReset: 'success' } });
      } catch (_e) {
        this.errorMessage = 'Unable to reset password. The link may have expired. Please request a new one.';
        this.error = true;
      }

      this.isLoading = false;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!to.query.token) {
      next({ name: 'login' });
    } else {
      next();
    }
  },
};
</script>
